import { render, staticRenderFns } from "./CustomerDeliveryAddressList.vue?vue&type=template&id=3babd68a&scoped=true"
import script from "./CustomerDeliveryAddressList.vue?vue&type=script&lang=js"
export * from "./CustomerDeliveryAddressList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3babd68a",
  null
  
)

export default component.exports